<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form class="mb-0" ref="form" data-url="/organizations/branchCritical">
        <div class="row">
<!--
          <div class="col-md-6">
            <div class="form-group">
              <label>Nombre</label>
              <app-input
                type="text"
                v-model="inputs.org.name"
                placeholder="Ingrese su nombre"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Razón Social</label>
              <app-input
                type="text"
                placeholder="Ingrese la razon social"
                v-model="inputs.org.business_name"
                :required="true"
              />
            </div>
          </div>
-->
          <div class="col-md-12">
            <div class="form-group">
              <label class="mb-0">Activo</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.org.is_active"
                :list="isActive"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>País</label>
              <app-input
                type="select"
                v-model="inputs.org.country_id"
                :required="true"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...this.$store.state.common.countries,
                ]"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="inputs.org.country_id && provinceList.length <= 1"
          >
            <div class="form-group">
              <label>Ciudad</label>
              <app-input
                type="text"
                v-model="inputs.org.city"
                placeholder="Ingrese la ciudad"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="provinceList.length > 1">
            <div class="form-group">
              <label>Provincia</label>
              <app-input
                type="select"
                v-model="inputs.org.province_id"
                :required="true"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...provinceList,
                ]"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="provinceList.length > 1">
            <div class="form-group">
              <label>Ciudad</label>
              <app-input
                type="select"
                v-model="inputs.org.canton_id"
                :required="true"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...cantonList,
                ]"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Dirección</label>
              <app-input
                type="textarea"
                v-model="inputs.org.address"
                :required="true"
                placeholder="Ingrese la dirección"
              />
            </div>
          </div>

         <div class="col-md-6" hidden=True >
            <div class="form-group">
              <label>Teléfono</label>
              <app-input
                type="tel-input"
                v-model="inputs.org.phone"
                placeholder="Ingrese su numero de telefono"
                :required="false"
              />
            </div>
          </div>
<!--
          <div class="col-md-6">
            <div class="form-group">
              <label>Responsable</label>
              <app-input
                type="text"
                v-model="inputs.org.legal_representative"
                placeholder="Ingrese el responsable"
                :required="true"
              />
            </div>
          </div>

         

          <div class="col-md-6">
            <div class="form-group">
              <label>E-mail</label>
              <app-input
                type="email"
                v-model="inputs.org.email"
                placeholder="Ingrese su email"
                :required="true"
              />
            </div>
          </div>
-->
          <!-- <div class="col-md-6">
            <div class="form-group">
              <label>N° de empleados</label>
              <app-input
                type="number"
                v-model="inputs.org.total_employees"
                :required="true"
                placeholder="Ingrese el nº de empleados"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Nº de auditores</label>
              <app-input
                type="number"
                v-model="inputs.org.fixed_auditors"
                :required="true"
                placeholder="Ingrese el nº de auditores"
              />
            </div>
          </div> -->

          <!-- <div class="col-md-12">
            <table id="critical-activities">
              <tr v-for="(value, key) in inputs.critical_activities" :key="key">
                <td
                  class="title"
                  :rowspan="inputs.critical_activities.length"
                  v-if="key === 0"
                >
                  Actividades Críticas Desempeñadas
                </td>
                <td>{{ key + 1 }}</td>
                <td class="name">
                  {{
                    value.critical_activity
                      ? value.critical_activity.name
                      : value.name
                  }}
                </td>
                <td class="is-checked">
                  <input type="checkbox" v-model="value.is_checked" />
                </td>
              </tr>
            </table>
          </div> -->
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    selectedUrl: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        org: {
          is_active: 1,
        },
        critical_activities: [],
      },
      modalId: "add-edit-modal",
      provinceList: [],
      cantonList: [],
      disabledSubmit: false,
      phone: "",
      isActive: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? "Editar" : "Registrar";
    },
  },
  watch: {
    "inputs.org.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.org.country_id
      );
    },

    "inputs.org.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.org.province_id
      );
    },

    "$store.state.common.countries": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.org.country_id
      );
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.org.province_id
      );
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    } else {
      this.getData();
    }
  },
  methods: {
    submit() {
      let i = 0;
      /* this.inputs.critical_activities.forEach((item) => {
        if (item.is_checked) i++;
      });
      if (i == 0) {
        this.$toastr.e(
          "Debe seleccionar las actividades críticas desempeñadas"
        );
        return;
      } */
      this.inputs.org.acc_app_id = this.$store.state.accreditation.id;
      this.inputs.org.establishment_type = "BC";
      this.disabledSubmit = true;
      this.save(this.inputs);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      if (this.inputs.org.id) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs.org = response.data.org;
      this.inputs.critical_activities = response.data.org.critical_activities;
      this.preloader = false;
    },

    getData() {
      this.preloader = true;

      this.axiosGet(
        `/organizations/branchCritical/criticalActivities?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.inputs.critical_activities = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
